import React, { useState } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import Classes from "../Profile.module.css";
import { DownloadIcon } from "../../../../../../utils/Icons";

const defaultAvatar = "/assets/images/user.png";
const MAX = 1000;

export default function BasicInfo({ initial = {}, uploadMedia, saveProfile }) {
  const [form, setForm] = useState({
    name: initial.name || "",
    title: initial.title || "",
    education: initial.education || "",
    clubs: initial.clubs || "",
    bio: initial.bio || "",
    avatar: initial.avatar || "",
    school: initial?.school || "",
    company: initial?.company || ""
  });
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(initial?.avatar || defaultAvatar);
  const [loading, setLoading] = useState(false);

  const change = e => setForm(p => ({ ...p, [e.target.name]: e.target.value }));
  const bio = e => {
    let v = e.target.value;
    if (v.length > MAX) v = v.slice(0, MAX);
    setForm(p => ({ ...p, bio: v }));
  };
  const fileChange = e => {
    const f = e.target.files[0];
    if (!f) return;
    setFile(f);
    setPreview(URL.createObjectURL(f));
  };

  const submit = async e => {
    e.preventDefault();
    let avatarUrl = form.avatar;
    if (file) avatarUrl = await uploadMedia([file]);
    await saveProfile({ basicInfo: { ...form, avatar: avatarUrl } });
  };

  return (
    <>
      <Backdrop open={loading} sx={{ zIndex: 1301, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <form className={Classes.infoCon} onSubmit={submit}>
        <h3>Basic Information</h3>

        {/* avatar */}
        <div className={Classes.changePicCon}>
          <img src={preview} alt="avatar" className={Classes.avatar} width={60} height={60} draggable={false} />
          <div className={Classes.picActions}>
            <h5 className={Classes.label}>Change Picture</h5>
            <label htmlFor="avatar-input" className={Classes.uploadBtn}>
              <DownloadIcon height="13" width="13" fill="#fff" />
              <h5>Upload Photo</h5>
              <input id="avatar-input" type="file" accept="image/*" hidden onChange={fileChange} />
            </label>
          </div>
        </div>

        {/* fields */}
        {[
          ["name", "Name", "Enter name"],
          ["title", "Professional Title", "Enter job title"],
          ["company", "Company", "Enter company"],
          ["education", "Education Level", "Enter education level"],
          ["school", "School", "Enter school"],
          ["clubs", "Clubs, Fraternities, and Charities", "Enter clubs, charities, or fraternities"],
        ].map(([k, l, ph]) => (
          <div key={k} className={Classes.flexColGroup}>
            <div className={Classes.flexCol1}>
              <div className="flexAlign10">
                <h5 className={Classes.label}>{l}</h5>
                {k === "clubs" &&
                  <div className="optionalText"><h5>Optional</h5></div>
                }
              </div>
              <input
                name={k}
                className={Classes.inputField}
                placeholder={ph}
                value={form[k]}
                onChange={change}
                required={k !== "clubs"}
              />
            </div>
          </div>
        ))}

        <div className={Classes.flexColGroup}>
          <div className={Classes.flexCol1}>
            <h5 className={Classes.label}>Short Bio</h5>
            <div className={Classes.textAreaCon}>
              <textarea
                name="bio"
                placeholder="Enter bio"
                className={Classes.textArea}
                rows={5}
                value={form.bio}
                onChange={bio}
              />
              <h5>{MAX - form.bio.length} Characters Remaining</h5>
            </div>
          </div>
        </div>

        <div className={Classes.flexEnd}>
          <button type="submit" className={Classes.saveBtn}><h5>Save</h5></button>
        </div>
      </form>
    </>
  );
}
